import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION,
  FETCH_PATIENTPAYMENTDETAILS_SUCCESS_ACTION,
  FETCH_PATIENTPAYMENTDETAILS_FAIL_ACTION,
  FETCH_PATIENTPAYMENTSTATUSCHANGE_INIT_ACTION,
  FETCH_PATIENTPAYMENTSTATUSCHANGE_SUCCESS_ACTION,
  FETCH_PATIENTPAYMENTSTATUSCHANGE_FAIL_ACTION,
  FETCH_PATIENT_REFUND_INIT_ACTION,
  FETCH_PATIENT_REFUND_SUCCESS_ACTION,
  FETCH_PATIENT_REFUND_FAIL_ACTION
} from "./action";

import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchPatientPayment(value) {
  const token = localStorage.getItem("token");
  let pageno = !value.value
    ? 1
    : value.value.page === undefined
      ? 1
      : value.value.page;
  let search = !value.value
    ? ""
    : value.value.search === ""
      ? ""
      : value.value.search;
  let status = !value.value
    ? ""
    : value.value.filter === ""
      ? ""
      : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/payment?userMode=chemist&&limit=10&page=${pageno}&status=${status}&search=${search}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_PATIENTPAYMENTDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PATIENTPAYMENTDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchPatientPaymentStatusChange(data) {
  let datas;

  data.value.item.status === "paid"
    ? (datas = {
      status: "cancelled"
    })
    : (datas = {
      status: "paid"
    });

  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/payment/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(datas)
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield toast.success("Status changed successfully", {
        autoClose: 3000
      });
      yield put({
        type: FETCH_PATIENTPAYMENTSTATUSCHANGE_SUCCESS_ACTION,
        payload: resJSON
      });

      const refreshParams =
        data &&
        data.value &&
        data.value.refreshParams
          ? data.value.refreshParams
          : undefined;
      yield put({
        type: FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION,
        value: refreshParams
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_PATIENTPAYMENTSTATUSCHANGE_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}


function* PatientRefundStatusChange(data) {
  const id = data.value.data.id;
  const datas = {
    status: 'refunded'
  };
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/payment/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(datas)
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield toast.success("Status changed successfully", {
        autoClose: 3000
      });
      yield put({
        type: FETCH_PATIENT_REFUND_SUCCESS_ACTION,
        payload: resJSON
      });

      const refreshParams =
        data &&
        data.value &&
        data.value.refreshParams
          ? data.value.refreshParams
          : undefined;
      yield put({
        type: FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION,
        value: refreshParams
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_PATIENT_REFUND_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}




export function* PatientPaymentActionWatcher() {
  yield takeEvery(FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION, fetchPatientPayment);
  yield takeEvery(
    FETCH_PATIENTPAYMENTSTATUSCHANGE_INIT_ACTION,
    fetchPatientPaymentStatusChange
  );
  yield takeEvery(FETCH_PATIENT_REFUND_INIT_ACTION, PatientRefundStatusChange);
}
